export default __webpack_public_path__ + "static/media/rocket.22199c05.svg";